import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Facebook(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), React.createElement("path", {
    d: "M1.656 0A1.656 1.656 0 000 1.656v26.688C0 29.26.741 30 1.656 30h14.369V18.382h-3.91v-4.527h3.91v-3.339c0-3.874 2.366-5.984 5.823-5.984a32.078 32.078 0 013.494.178v4.046h-2.398c-1.88 0-2.248.894-2.248 2.204v2.891h4.484l-.583 4.528H20.7V30h7.643C29.26 30 30 29.259 30 28.344V1.656C30 .742 29.26 0 28.345 0H1.655z",
    mask: "url(#mask-2)"
  }));
}

export { Facebook };
//# sourceMappingURL=Facebook.js.map